import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const cityImporterSelectors =
  importerSelectors('city.importer')

export default cityImporterSelectors
